import { render, staticRenderFns } from "./ConsignatariaFormDialog.vue?vue&type=template&id=461fc4ca&scoped=true&"
import script from "./ConsignatariaFormDialog.vue?vue&type=script&lang=js&"
export * from "./ConsignatariaFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConsignatariaFormDialog.vue?vue&type=style&index=0&id=461fc4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461fc4ca",
  null
  
)

export default component.exports